import { render, staticRenderFns } from "./ExchangeSettings.vue?vue&type=template&id=15513496&scoped=true&lang=pug"
import script from "./ExchangeSettings.vue?vue&type=script&lang=js"
export * from "./ExchangeSettings.vue?vue&type=script&lang=js"
import style0 from "./ExchangeSettings.vue?vue&type=style&index=0&id=15513496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15513496",
  null
  
)

export default component.exports